// src/context/GlobalContext.tsx
import React, { createContext, useContext, useState } from "react";

type GlobalState = {
  env: string;
  setEnv: (v: string) => void;
  globalTeamId: number;
  setGlobalTeamId: (v: number) => void;
  globalTimeout: number;
  setGlobalTimeout: (v: number) => void;
  showDataSourceSelector: boolean;
  setShowDataSourceSelector: (v: boolean) => void;
};

const GlobalContext = createContext<GlobalState | null>(null);

export const GlobalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [env, setEnv] = useState("gamma");
  const [globalTeamId, setGlobalTeamId] = useState(0);
  const [globalTimeout, setGlobalTimeout] = useState(300);
  const [showDataSourceSelector, setShowDataSourceSelector] = useState(false);

  return (
    <GlobalContext.Provider
      value={{
        env,
        setEnv,
        globalTeamId,
        setGlobalTeamId,
        globalTimeout,
        setGlobalTimeout,
        showDataSourceSelector,
        setShowDataSourceSelector,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const ctx = useContext(GlobalContext);
  if (!ctx) throw new Error("useGlobal must be used within GlobalProvider");
  return ctx;
};
